import {
  getModuleTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
import { generateId } from '@utils/id'
import moduleConfig from '../../config'

const __tc = getRootPluaralTranslator()
const __mtc = getModuleTranslator(moduleConfig.translationKey)

export const osComponentFieldMap = () => ({
  os_component: {
    canCreate: true,
    maxCreation: 1,
    title: __tc('os_component'),
    fields: [
      {
        key: generateId(),
        paramName: 'manufacturerId',
        name: __tc('manufacturer'),
        inputType: 'manufacturer',
      },
      {
        key: generateId(),
        paramName: 'osName',
        name: __tc('os_name'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'osVersion',
        name: __tc('os_version'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'architecture',
        name: __tc('os_architecture'),
        inputType: 'dropdown',
        contextOptionKey: 'osArchitectureOptions',
      },
      {
        key: generateId(),
        paramName: 'productKey',
        name: __mtc('product_key'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'licenceKey',
        name: __mtc('licence_key'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'activationStatus',
        name: __tc('activation_status'),
        inputType: 'dropdown',
        contextOptionKey: 'activationStatusOptions',
      },
      {
        key: generateId(),
        paramName: 'installedDate',
        name: __tc('installed_date'),
        inputType: 'dateTime',
      },
      {
        key: generateId(),
        paramName: 'displayVersion',
        name: __mtc('display_version'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'buildNo',
        name: __mtc('build_no'),
        inputType: 'text',
      },
    ],
  },
})
